import React from "react";
export var AssignDefaultsModeContext = React.createContext({
  inAssignDefaultsMode: false,
  setAssignDefaultsMode: function setAssignDefaultsMode() {}
});
export var workflowDefaultParamsObj = {
  taskNumber: undefined,
  workflowDefinitionName: undefined,
  workflowDefinitionId: undefined,
  workflowRunName: undefined,
  workflowRunId: undefined,
  toolName: undefined,
  workflowToolTitle: undefined,
  workflowTaskCode: undefined
};
export var WorkflowDefaultParamsContext = React.createContext(workflowDefaultParamsObj);